<template>
  <div class="main_box">
    <div class="main_bar" v-if="false">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <span class="currentSpan">投票管理</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div></div>
    </div>
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item"></div>
        </div>
        <div class="form_bar_btn">
          <el-button type="primary" @click="getVoteList()" size="small" plain>
            刷新
          </el-button>
          <el-button
            type="primary"
            @click="createVote()"
            v-show="voteItems.length > 0"
          >
            新增投票
          </el-button>
          <el-button
            type="primary"
            @click="voteResultsSummary()"
            v-show="voteItems.length > 0"
          >
            结果汇总
          </el-button>
          <el-button
            type="primary"
            @click="openClearMeetingData()"
            v-if="userRole === 1"
          >
            清除数据
          </el-button>
        </div>
      </div>
      <el-empty
        description="暂无投票"
        v-loading="voteListLoading"
        v-show="voteItems.length === 0"
      >
        <el-button type="primary" @click="createVote()"> 新增投票 </el-button>
      </el-empty>
      <el-table
        row-key="Id"
        :data="voteItems"
        stripe
        ref="voteItemsTable"
        style="width: 100%"
        v-loading="voteListLoading"
        v-show="voteItems.length > 0"
      >
        <el-table-column
          type="index"
          :index="voteIndexMethod"
          label="序号"
          width="50"
          v-if="!is_xs"
        >
        </el-table-column>
        <el-table-column label="名称" min-width="140">
          <template slot-scope="scope">
            <el-link
              v-html="scope.row.VoteName"
              @click="lookVote(scope.row.Id, scope.row.QuestionnaireId)"
            >
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="StrVoteType"
          label="类型"
          width="80"
          v-if="meetingInfo.MeetingType === 0"
        >
        </el-table-column>
        <el-table-column prop="SelectProjectNum" label="待评项" width="80">
        </el-table-column>
        <el-table-column prop="SelectUserNum" label="投票人" width="80">
        </el-table-column>
        <el-table-column
          prop="RuleName"
          label="规则"
          width="160"
          v-if="meetingInfo.MeetingType === 0"
        >
        </el-table-column>
        <el-table-column prop="StrState" label="状态" width="80">
        </el-table-column>
        <!-- <el-table-column label="监控" width="200">
          <template slot-scope="scope">
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.VoteType != 3"
              @click="voteSetting(scope.row)"
            >
              配置
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.VoteType != 3"
              @click="voteDetail(scope.row)"
            >
              明细
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.VoteType != 3"
              @click="voteResult(scope.row)"
            >
              结果
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.VoteType != 3"
              @click="voteProgress(scope.row)"
            >
              检查
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.VoteType == 3"
              @click="screenVoteResult(scope.row)"
            >
              投屏结果
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.VoteType == 3"
              @click="openLargeScreen(scope.row)"
            >
              大屏幕
            </el-link>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="300" align="right">
          <template slot-scope="scope">
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.Status == 0"
              @click="editVote(scope.row.Id, scope.row.QuestionnaireId)"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.Status == 0"
              @click="deleteVote(scope.row)"
            >
              删除
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.Status == 0"
              @click="startVote(scope.row)"
            >
              开始投票
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.Status == 1"
              @click="endVote(scope.row)"
            >
              结束投票
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.Status == 3"
              @click="colseVote(scope.row)"
              title="关闭投票后，评委端不再显示当前投票"
            >
              关闭投票
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="
                userRole === 1 &&
                (scope.row.Status == 3 || scope.row.Status == 4)
              "
              @click="resetVote(scope.row)"
            >
              重新投票
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.Status !== 3 && scope.row.Status !== 4"
              @click="voteSetting(scope.row)"
            >
              高级配置
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click="voteWatch(scope.row)"
              v-if="scope.row.VoteType !== 5"
            >
              投票监控
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click="questionnaireWatch(scope.row)"
              v-if="scope.row.VoteType === 5"
            >
              问卷监控
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.VoteType == 3 && false"
              @click="screenVoteResult(scope.row)"
            >
              投屏结果
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="
                ((scope.row.VoteType == 0 && scope.row.IsScreen) ||
                  scope.row.VoteType == 3) &&
                scope.row.Status !== 4
              "
              @click="openLargeScreen(scope.row)"
            >
              投大屏幕
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="
                scope.row.VoteType == 0 &&
                scope.row.IsScreen &&
                scope.row.Status !== 4
              "
              @click="initShortlistedLargeScreen(scope.row)"
            >
              初始屏幕
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.VoteType == 3 && scope.row.Status !== 4"
              @click="initLargeScreen(scope.row)"
            >
              初始屏幕
            </el-link>
            <el-link
              title="快速创建投票"
              type="primary"
              class="cell_link"
              v-if="
                ((scope.row.VoteType == 0 && scope.row.IsScreen) ||
                  scope.row.VoteType == 3) &&
                scope.row.Status !== 0 &&
                !scope.row.QuickCreateVoteId
              "
              @click="quickCreateVote(scope.row)"
            >
              生成投票
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="
                userRole === 1 &&
                scope.row.VoteType == 3 &&
                scope.row.QuickCreateVoteId
              "
              @click="eidtQuickCreateVote(scope.row)"
            >
              解绑特等奖投票
            </el-link>
            <el-link
              title="完成系列投票"
              type="primary"
              class="cell_link"
              v-if="
                scope.row.VoteType == 0 &&
                scope.row.IsScreen &&
                scope.row.QuickCreateVoteIndex
              "
              @click="completeAllVote(scope.row)"
            >
              完成比赛
            </el-link>
            <el-link
              title="查看进升组排名"
              type="primary"
              class="cell_link"
              v-if="
                scope.row.VoteType == 0 &&
                scope.row.IsScreen &&
                scope.row.QuickCreateVoteIndex
              "
              @click="openUpgradeGroupRanking(scope.row)"
            >
              进升组排名
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="voteListQuery.maxResultCount"
        :layout="pagination_layout"
        :total="voteTotalCount"
        v-show="voteItems.length > 0"
      >
      </el-pagination>
      <div style="margin: 20px 0px 0px 0px">
        操作注意事项：
        <br />
        1、点击"
        <span style="color: #409eff">编辑</span>
        "，可以对投票信息进行编辑，投票开始后不能编辑投票信息；
        <br />
        2、点击"
        <span style="color: #409eff">删除</span>
        "，可以删除该投票，投票开始后不能删除投票信息；
        <br />
        3、点击"
        <span style="color: #409eff">开始投票</span>
        "，投票人扫描二维码可以看到当前投票；
        <br />
        4、点击"
        <span style="color: #409eff">结束投票</span>
        "，当前投票结束，投票终止，结束后的投票不计入结果；
        <br />
        5、点击"
        <span style="color: #409eff">关闭投票</span>
        "，归档投票信息，投票端看不到关闭的投票；
        <br />
        6、点击"
        <span style="color: #409eff">投票监控</span>
        "，可以查看投票进度、结果、明细；
        <br />
        7、点击"
        <span style="color: #409eff">高级配置</span>
        "，更详细的投票设置；
      </div>
    </div>
    <el-dialog
      title="清除数据"
      :visible.sync="dialogClearMeetingDataVisible"
      custom-class="custom_dialog"
    >
      <div class="create_meeting_from_box">
        <el-form
          :model="clearMeetingDataForm"
          ref="clearMeetingDataForm"
          label-width="160px"
          class="demo-ruleForm"
          :label-position="is_xs ? 'top' : 'left'"
        >
          <el-form-item label="清除投票信息：">
            <el-switch v-model="clearMeetingDataForm.IsClearVote"> </el-switch>
          </el-form-item>
          <el-form-item label="清除人员信息：" prop="IsClearUser">
            <el-switch v-model="clearMeetingDataForm.IsClearUser"> </el-switch>
          </el-form-item>
          <el-form-item label="清除项目信息：" prop="IsClearProject">
            <el-switch v-model="clearMeetingDataForm.IsClearProject">
            </el-switch>
          </el-form-item>
          <el-form-item label="清除规则信息：" prop="IsClearRule">
            <el-switch v-model="clearMeetingDataForm.IsClearRule"> </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button @click="dialogClearMeetingDataVisible = false">
              取消
            </el-button>
            <el-button type="primary" @click="ClearMeetingData()">
              确认清除数据
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import voteManageApi from '../../../api/vote/voteManage' // voteManage投票管理接口
import Sortable from 'sortablejs'
export default {
  data () {
    return {
      voteListLoading: true,
      voteTotalCount: 0,
      voteListQuery: {
        meetingId: null,
        maxResultCount: 10,
        skipCount: 0
      },
      currentPage: 1,
      pagination_layout: 'prev, pager, next',
      voteItems: [],
      userRole: -1,
      dialogClearMeetingDataVisible: false,
      clearMeetingDataForm: {
        MeetingId: null,
        IsClearVote: true,
        IsClearUser: false,
        IsClearProject: false,
        IsClearRule: false
      }
    }
  },
  props: ['voteListPagingQuery', 'meetingInfo'],
  methods: {
    getVoteList: function () {
      this.voteListLoading = true
      voteManageApi.getVoteList({
        meetingId: this.voteListQuery.meetingId,
        skipCount: this.voteListQuery.skipCount,
        maxResultCount: this.voteListQuery.maxResultCount
      })
        .then(data => {
          this.voteItems = data.Items
          this.voteTotalCount = data.TotalCount
          this.$nextTick(function () {
            this.$refs.voteItemsTable.doLayout()
          })
          this.voteListLoading = false
        }).catch(err => {
          this.voteListLoading = false
          return err
        })
    },
    voteIndexMethod (index) {
      return index + this.voteListQuery.skipCount + 1
    },
    openLargeScreen (row) {
      if (row.VoteType === 3) {
        const routerJump = this.$router.resolve({ name: 'largeScreen', params: { vid: row.Id } })
        window.open(routerJump.href, '_blank')
      }
      if (row.VoteType === 0) {
        const routerJump = this.$router.resolve({ name: 'shortlistedScreen', params: { vid: row.Id } })
        window.open(routerJump.href, '_blank')
      }
    },
    initLargeScreen (item) {
      const _this = this
      _this.$confirm('确认初始化大屏幕吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = _this.openLoading()
        voteManageApi.editScreenFlow({
          MeetingId: _this.$route.params.mid,
          VoteId: item.Id,
          GroupId: null,
          ProjectId: null,
          StepId: '1',
          IsBegin: null,
          IsSendMessage: true,
          IsAdmin: true
        }).then(data => {
          openLoading.close()
          _this.getVoteList()
          _this.$message({
            type: 'success',
            message: '初始化大屏幕成功！',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消初始化大屏幕',
          customClass: 'custom_message'
        })
      })
    },
    initShortlistedLargeScreen (item) {
      const _this = this
      _this.$confirm('确认初始化大屏幕吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = _this.openLoading()
        voteManageApi.editShortlistedScreenFlow({
          MeetingId: _this.$route.params.mid,
          VoteId: item.Id,
          VoteType: 0,
          GroupId: null,
          ProjectId: null,
          StepId: '002',
          IsBegin: null
        }).then(data => {
          openLoading.close()
          _this.getVoteList()
          _this.$message({
            type: 'success',
            message: '初始化大屏幕成功！',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消初始化大屏幕',
          customClass: 'custom_message'
        })
      })
    },
    handleSizeChange (val) {
      this.voteListQuery.maxResultCount = val
      this.$emit('changePaging', this.voteListQuery.skipCount, this.voteListQuery.maxResultCount, this.currentPage)
      this.getVoteList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.voteListQuery.skipCount = (val - 1) * this.voteListQuery.maxResultCount
      this.$emit('changePaging', this.voteListQuery.skipCount, this.voteListQuery.maxResultCount, this.currentPage)
      this.getVoteList()
    },
    createVote: function () {
      this.$router.push({ name: 'createVote', params: { mid: this.$route.params.mid, vid: '0', qid: '0' } })
    },
    editVote: function (voteId, questionnaireId) {
      if (!questionnaireId) {
        questionnaireId = '0'
      }
      this.$router.push({ name: 'editVote', params: { mid: this.$route.params.mid, vid: voteId, qid: questionnaireId } })
    },
    lookVote: function (voteId, questionnaireId) {
      if (!questionnaireId) {
        questionnaireId = '0'
      }
      this.$router.push({ name: 'editVote', params: { mid: this.$route.params.mid, vid: voteId, qid: questionnaireId } })
    },
    deleteVote: function (item) {
      this.$confirm('确认删除投票“' + item.VoteName + '”吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('删除中…')
        voteManageApi.deleteVote({
          voteId: item.Id
        }).then(data => {
          openLoading.close()
          this.getVoteList()
          this.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    startVote: function (item) {
      this.$confirm('确认开始投票“' + item.VoteName + '”吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('投票启动中…')
        voteManageApi.startVote({
          VoteId: item.Id
        }).then(data => {
          openLoading.close()
          this.getVoteList()
          this.$message({
            type: 'success',
            message: item.VoteName + ' 投票启动成功！',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消开始投票操作',
          customClass: 'custom_message'
        })
      })
    },
    resetVote: function (item) {
      this.$confirm('确认重置投票“' + item.VoteName + '”吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('投票重置中…')
        voteManageApi.resetVote({
          VoteId: item.Id
        }).then(data => {
          openLoading.close()
          this.getVoteList()
          this.$message({
            type: 'success',
            message: item.VoteName + ' 投票重置成功！',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消重置投票操作',
          customClass: 'custom_message'
        })
      })
    },
    endVote: function (item) {
      this.$confirm('确认结束投票“' + item.VoteName + '”吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('投票结束中…')
        voteManageApi.endVote({
          VoteId: item.Id
        }).then(data => {
          openLoading.close()
          this.getVoteList()
          this.$message({
            type: 'success',
            message: item.VoteName + ' 投票已经结束！',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消结束投票操作',
          customClass: 'custom_message'
        })
      })
    },
    colseVote: function (item) {
      this.$confirm('确认关闭投票“' + item.VoteName + '”吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('投票关闭中…')
        voteManageApi.colseVote({
          VoteId: item.Id
        }).then(data => {
          openLoading.close()
          this.getVoteList()
          this.$message({
            type: 'success',
            message: item.VoteName + ' 投票已经关闭！',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消关闭投票操作',
          customClass: 'custom_message'
        })
      })
    },
    eidtQuickCreateVote: function (item) {
      this.$confirm('确认删除特等奖投票绑定吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading()
        voteManageApi.eidtQuickCreateVote({
          VoteId: item.Id
        }).then(data => {
          openLoading.close()
          this.getVoteList()
          this.$message({
            type: 'success',
            message: '特等奖投票绑定已删除',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除特等奖投票绑定操作',
          customClass: 'custom_message'
        })
      })
    },
    quickCreateVote: function (item) {
      this.$confirm('确认快速创建投票吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('生成投票中…')
        voteManageApi.quickCreateVote({
          SourceVoteId: item.Id
        }).then(data => {
          openLoading.close()
          this.getVoteList()
          this.$message({
            type: 'success',
            message: '投票已生成！',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消快速创建投票',
          customClass: 'custom_message'
        })
      })
    },
    completeAllVote: function (item) {
      this.$confirm('确认完成比赛吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading()
        voteManageApi.completeAllVote({
          VoteId: item.Id
        }).then(data => {
          openLoading.close()
          this.getVoteList()
          this.$message({
            type: 'success',
            message: '投票已完成！',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
          customClass: 'custom_message'
        })
      })
    },
    openUpgradeGroupRanking: function (item) {
      this.$confirm('确认查看进升组排名吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading()
        voteManageApi.openUpgradeGroupRanking({
          VoteId: item.Id
        }).then(data => {
          openLoading.close()
          this.getVoteList()
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
          customClass: 'custom_message'
        })
      })
    },
    voteDetail: function (item) {
      this.$router.push({
        name: 'voteDetail',
        params: { mid: this.$route.params.mid, vid: item.Id, s: this.voteListQuery.skipCount, m: this.voteListQuery.maxResultCount }
      })
      //   const routerJump = this.$router.resolve({
      //     name: 'voteDetail',
      //     params: { mid: this.$route.params.mid, vid: item.Id, s: this.voteListQuery.skipCount, m: this.voteListQuery.maxResultCount }
      //   })
      //   window.open(routerJump.href, '_blank')
    },
    voteResult: function (item) {
      this.$router.push({
        name: 'voteResult',
        params: { mid: this.$route.params.mid, vid: item.Id, s: this.voteListQuery.skipCount, m: this.voteListQuery.maxResultCount }
      })
    },
    voteProgress: function (item) {
      this.$router.push({
        name: 'voteProgress',
        params: { mid: this.$route.params.mid, vid: item.Id, s: this.voteListQuery.skipCount, m: this.voteListQuery.maxResultCount }
      })
    },
    voteWatch: function (item) {
      this.$router.push({
        name: 'watchVote',
        params: { mid: this.$route.params.mid, vid: item.Id, votetype: item.VoteType }
      })
    },
    questionnaireWatch: function (item) {
      this.$router.push({ name: 'voteWatchQuestionnaire', params: { mid: this.$route.params.mid, qid: item.QuestionnaireId } })
    },
    voteResultsSummary: function () {
      this.$router.push({
        name: 'voteResultsSummary',
        params: { mid: this.$route.params.mid }
      })
    },
    screenVoteResult: function (item) {
      this.$router.push({
        name: 'voteScreenResult',
        params: { mid: this.$route.params.mid, vid: item.Id, s: this.voteListQuery.skipCount, m: this.voteListQuery.maxResultCount }
      })
    },
    voteSetting: function (item) {
      this.$router.push({
        name: 'voteSetting',
        params: { mid: this.$route.params.mid, vid: item.Id }
      })
    },
    getCurrentUserRole: function () {
      this.$api.userInfo.getCurrentUserRole().then(data => {
        this.userRole = data
      }).catch(err => {
        return err
      })
    },
    setSort () {
      const _this = this
      const el = _this.$refs.voteItemsTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      Sortable.create(el, {
        // ghostClass: 'sortable-ghost',
        // setData: function (dataTransfer) {
        //   dataTransfer.setData('Text', '')
        // },
        onEnd: evt => {
          //   const targetRow = _this.voteItems.splice(evt.oldIndex, 1)[0]
          //   _this.voteItems.splice(evt.newIndex, 0, targetRow)
          const sortItems = []
          if (evt.oldIndex > evt.newIndex) {
            const sortItem = {}
            sortItem.VoteId = _this.voteItems[evt.oldIndex].Id
            sortItem.Sort = _this.voteItems[evt.newIndex].Sort
            sortItem.VoteName = _this.voteItems[evt.oldIndex].VoteName
            sortItems.push(sortItem)
            for (let i = evt.newIndex; i < evt.oldIndex; i++) {
              const sortItem = {}
              sortItem.voteId = _this.voteItems[i].Id
              sortItem.sort = _this.voteItems[i].Sort - 1
              sortItem.VoteName = _this.voteItems[i].VoteName
              sortItems.push(sortItem)
            }
          }
          if (evt.oldIndex < evt.newIndex) {
            const sortItem = {}
            sortItem.VoteId = _this.voteItems[evt.oldIndex].Id
            sortItem.Sort = _this.voteItems[evt.newIndex].Sort
            sortItem.VoteName = _this.voteItems[evt.oldIndex].VoteName
            sortItems.push(sortItem)
            for (let i = evt.newIndex; i > evt.oldIndex; i--) {
              const sortItem = {}
              sortItem.voteId = _this.voteItems[i].Id
              sortItem.sort = _this.voteItems[i].Sort + 1
              sortItem.VoteName = _this.voteItems[i].VoteName
              sortItems.push(sortItem)
            }
          }
          // console.log(sortItems)
          const openLoading = this.openLoading()
          voteManageApi.sortVote(sortItems).then(data => {
            openLoading.close()
            this.getVoteList()
          }).catch(err => {
            openLoading.close()
            return err
          })
        }
      })
    },
    openClearMeetingData: function () {
      const _this = this
      _this.dialogClearMeetingDataVisible = true
    },
    ClearMeetingData: function () {
      const _this = this
      this.$confirm('确认清空指定数据吗！！！是否继续？', '提示-清空数据', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'custom_message_box'
      }).then(() => {
        _this.openLoading()
        _this.clearMeetingDataForm.MeetingId = _this.$route.params.mid
        voteManageApi.clearMeetingData(_this.clearMeetingDataForm).then(data => {
          _this.openLoading().close()
          _this.dialogClearMeetingDataVisible = false
          _this.voteListQuery.skipCount = 0
          _this.getVoteList()
          _this.$message({
            type: 'success',
            message: '数据已清空',
            customClass: 'custom_message'
          })
        }).catch(err => {
          _this.openLoading().close()
          return err
        })
      }).catch(() => {
        this.$message({
          showClose: true,
          type: 'info',
          message: '已取消清空数据',
          customClass: 'custom_message'
        })
      })
    }
  },
  mounted () {
    if (!this.is_xs) {
      this.setSort()
    }
  },
  created () {
    this.voteListQuery.meetingId = this.$route.params.mid
    this.voteListQuery.skipCount = this.voteListPagingQuery.skipCount
    this.voteListQuery.maxResultCount = this.voteListPagingQuery.maxResultCount
    this.currentPage = this.voteListPagingQuery.currentPage
    this.getVoteList()
    this.getCurrentUserRole()
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
  }
}
</script>
<style lang="less">
</style>
